export const PATHS = {
  BASE_API_PATH: '/',
  PROFILE: 'profile?website_url={website_url}',
  SEARCH_USER:
    'profile/search?website_url={website_url}&name={name}&sort_by=name',
  FETCH_PREVIEW: 'fetch/preview?website_url={website_url}',
  FETCH_POST_OR_TOPIC:
    'fetch/{slug}?website_url={website_url}&community_slug={communitySlug}&show_hidden={showHidden}',

  POST: {
    LIST:
      'post?website_url={website_url}&slug={slug}&pin={pin}&page={page}&community_id={communityId}&topic_id={topicId}&sort_by={sort}&id={id}&items_per_page={pageSize}&exclude={exclude}&article_id={articleId}&ignore-cache={ignoreCache}',
    DETAIL_BY_ID_OR_SLUG: 'post/{idSlug}?website_url={website_url}',
    CREATE: 'post/create?website_url={website_url}',
    LIKE: 'post/{id}/like?website_url={website_url}',
    DELETE: 'post/{id}/delete?website_url={website_url}',
    REPORT: 'post/{id}/report?website_url={website_url}',
    UPDATE: 'post/{id}/update?website_url={website_url}',
    FOLLOW: 'post/{id}/follow?website_url={website_url}',
  },
  COMMENT: {
    LIST:
      'comment?website_url={website_url}&post_id={postId}&page={page}&sort_by={sort}&items_per_page={perPage}&_without_reply={withoutReply}',
    CREATE: 'comment/create?website_url={website_url}',
    REPLY: 'comment/reply?website_url={website_url}',
    DELETE: 'comment/{id}/delete?website_url={website_url}',
    LIKE: 'comment/{id}/like?website_url={website_url}',
    UNLIKE: 'comment/{id}/unlike?website_url={website_url}',
    IMAGE_UPLOAD: 'comment/image/upload?website_url={website_url}',
    DETAIL: 'comment/{id}?website_url={website_url}',
    UPDATE: 'comment/{id}/update?website_url={website_url}',
  },
  COMMUNITY: {
    LIST: 'community?website_url={website_url}&page={page}',
    DETAIL_BY_ID_OR_SLUG: 'community/{idSlug}?website_url={website_url}',
    JOIN: 'community/join?website_url={website_url}',
    LEAVE: 'community/leave?website_url={website_url}',
    SITE_WIDE_BANNER: 'sitewide/{type}/{id}?website_url={website_url}',
  },
  TOPIC: {
    LIST:
      'topic?website_url={website_url}&community_slug={communitySlug}&community_id={communityId}&page={page}&due_date_month={dueDateMonth}&items_per_page={pageSize}',
    DETAIL_BY_ID_OR_SLUG:
      'topic/{idSlug}?website_url={website_url}&community_slug={communitySlug}&community_id={communityId}',
    HEALTH_TOOLS: 'tools?topic_id={topicId}&website_url={website_url}',
    SUBOTS: 'subots?topic_id={topicId}&website_url={website_url}',
    SUGGESTED_POSTS:
      'suggested-posts?topic_id={topicId}&website_url={website_url}&page={page}',
    JOIN: 'topic/join?website_url={website_url}',
    LEAVE: 'topic/leave?website_url={website_url}',
  },
  BOOKMARK: {
    LIST: 'bookmark?user_id={userId}&website_url={website_url}',
    CREATE: 'bookmark/create?website_url={website_url}',
    DELETE: 'bookmark/delete?website_url={website_url}',
  },
  HOMEPAGE: {
    BANNER: 'banners?website_url={website_url}',
    STATIC_NUMBERS: 'static-numbers?website_url={website_url}',
    VIDEO: 'options?website_url={website_url}&meta_key=video_community',
    EXPERT: 'options?website_url={website_url}&meta_key=expert_community',
    SITE_WIDE_BANNER: 'sitewide/home?website_url={website_url}',
  },
  POST_LEAD_LEAD: 'campaign/{campaignCode}/lead',
}
export const SUBOT_PATHS = {
  TOGETHER: {
    SURVEY: {
      GET_FIRST_NODE: 'frontend/api/bots/{botId}',
      CHAT_WITH_BOT: 'frontend/api/inline/messages',
      GET_SUBOT_LOG: 'frontend/api/log/bot/{botId}/{cookieId}/{accountId}',
      POST_SUBOT_CREATE_LOG: 'frontend/api/log/bot',
    },
  },
}

export const CARE_PATHS = {
  GET_DOCTORS: 'doctors?site={site}&status=1&keyword=&page={page}',
  GET_HOSPITALS:
    'hospital/branches?site={site}&page={page}&_without_bookable=1&_get_type=short',
  GET_DOCTOR_INFO: 'doctors/{doctorId}?site={site}',
  GET_HOSPITAL_INFO: 'hospital/branch/{id}?site={site}',
}
export const DISCOVER_PATHS = {
  BASE_API_PATH: '/',
  GET_SEARCH_ARTICLES: 'search?s={keyword}&page={page}',
  // GET_TOP_CATEGORIES: 'categories',
  GET_ALL_CATEGORIES: 'categories?type=all',
  GET_HOMEPAGE_POSTS: 'home/trending-post?type={type}',
  GET_HOMEPAGE_LATEST_POSTS: 'articles?page=1&_islatest=1',
  GET_ARTICLE_DETAIL:
    'article/{slug}?skip_ids={skipIds}&_isrelated={isRelated}',
  GET_CATEGORY_DETAIL: 'category/{slug}',
  GET_CATEGORY_OR_ARTICLE_DETAIL: 'fetch/{fullSlug}',
  GET_PREVIEW_ARTICLE: 'fetch/{fullSlug}?preview_nonce={nonce}&preview=true',
  GET_ARTICLE_OF_CATEGORY:
    'articles?category_id={categoryId}&page={currentPage}',
  GET_PAGE_STATIC: 'page/{slug}',
  GET_ALL_HEALTH_TOOLS: 'healthtools',
  GET_ALL_MARRYBABY_HEALTH_TOOLS: 'health-tools',
  GET_HEALTH_TOOLS_BY_CATEGORY: 'healthtools?_hasgroup=1',
  GET_AUTHOR: 'author/{slug}',
  GET_ALL_EXPERTS: 'experts',
  GET_ALL_EXPERTS_PAGING: 'experts?page={page}',
  GET_EXPERT: 'expert/{slug}',
  GET_EXPERT_POST: 'expert/article?page={page}',
  POST_ARTICLE_FEEDBACK: 'article/feedback/{id}',
  GET_AZ_DRUGS: 'category/a-z/{category}',
  GET_HOMEPAGE_MEDICAL_REVIEWED: 'home/medical-reviewed',
  GET_ARTICLES_BY_IDS: 'articles?ids={ids}',
  GET_ARTICLE_OF_CATEGORY_NO_EXPLAINERS:
    'articles?category_id={categoryId}&page={currentPage}&skip_ids={ids}',
  GET_EXPERT_OF_CATEGORY: 'category/expert/?id={id}',
  GET_DUE_DATE_INFO: 'health-tools/due-date-calculator/info',
  GET_DUE_DATE_ALL_WEEKS: 'health-tools/due-date-calculator/all',
  GET_DUE_DATE_SUGGESTED_ARTICLES:
    'health-tools/due-date-calculator/result?from_week={from}&to_week={to}',
  GET_PROFILE: 'user/profile',
  GET_ADMIN_PROFILE: 'GET_ADMIN_PROFILE',
  GET_FEATURE: 'feature',
  POST_NEW_FEATURE: 'feature/update',
  CREATE_BOOKMARK: 'bookmark/create',
  DELETE_BOOKMARK: 'bookmark/delete',
  DELETE_ALL_BOOKMARK: 'bookmark/delete-all',
  GET_ALL_BOOKMARK: 'bookmark',
  SSO_USER_PROFILE: 'user',
  SSO_USER_BOOKMARKS: 'user/bookmarks',
  SSO_USER_PASSWORD: 'user/settings/password',
  SSO_USER_EMAIL: 'user/settings/update-email',
  SSO_CLOSE_ACCOUNT: 'user/settings/close-account',
  SSO_HELP: 'user/settings/help',
  GET_HEALTH_TOOL_OVULATION_INFO: 'health-tools/ovulation-calculator/info',
  GET_HEALTH_TOOL_OVULATION_SUGGESTED_ARTICLES:
    'health-tools/ovulation-calculator/result?method={method}', // method: 1, 2, 3
  GET_HEALTH_TOOL_BMI_INFO: 'health-tools/bmi-calculator/info',
  GET_HEALTH_TOOL_BMI_RESULT:
    'health-tools/bmi-calculator/result?gender={gender}&bmi={bmi}&age={age}',
  GET_HEALTH_TOOL_BMR_INFO: 'health-tools/bmr-calculator/info',
  GET_HEALTH_TOOL_BMR_RESULT:
    'health-tools/bmr-calculator/result?kcals={kcals}&gender={gender}&age={age}',
  GET_HEALTH_TOOL_PWG_INFO: 'health-tools/preweight-gain-calculator/info',
  GET_HEALTH_TOOL_THR_INFO: 'health-tools/target-heart-rate/info',
  GET_HEALTH_TOOL_BABY_POOP: 'health-tools/baby-poop-tool',
  POST_UPDATE_LOCATION: 'tracking/geo/',
  // SIDIS
  GET_SIDIS_DUE_DATE: 'frontend/tools/due_date',
  GET_SIDIS_OVULATION: 'frontend/tools/ovulation',
  GET_SIDIS_BMI: 'frontend/tools/bmi',
  GET_SIDIS_BMR: 'frontend/tools/bmr',
  POST_LOGOUT: 'user/logout',
  OVULATION_CREATE_EVENT:
    'ovulation/event?method={method}&day={day}&cycle={cycle}&period={period}&token={token}&user_id={user_id}',
  GET_ALL_SPOTLIGHT: 'spotlights?per_page={perPage}&order_by={orderBy}',
  SSO_UPDATE_FIRST_TIME_BOOKMARK: 'bookmark/update-first-time',
  POST_COMMENT_NOTIFICATION: 'comment/notification',
  GET_ABOUT_US_DATA: 'about',
  POST_LEAD_IMPRESSION: 'campaign/{campaignCode}/impression',
  POST_LEAD_POPUP_EXIT: 'campaign/{campaignCode}/popup_exit',
  POST_LEAD_LEAD: 'campaign/{campaignCode}/lead',
  POST_SSO_VERIFY_TOKEN: 'verify-id-token',
  GET_LANDING_PAGE_FIRST_NODE: 'landing_page/bot',
  GET_LANDING_PAGE_NEXT_NODE: 'landing_page/messages',
  POST_LANDING_PAGE_IMPRESSION: 'landing_page/impressions',
  POST_LANDING_PAGE_CLICK: 'landing_page/clicks',
  FETCH_URL_DATA: 'preview',
  GET_SPOTLIGHT_LANDING: 'spotlight/{slug}',
  CHECK_SSO_EMAIL: 'member/check-email',
  GET_HOMEPAGE_SITEWIDE_BANNER: 'home/sitewide-banner',
  GET_DYNAMIC_FOOTER: 'footer',
  GET_EXPERTS: 'experts?page={page}&number={perPage}&s={search}',
  GET_EXPERT_BY_ID: 'expert/{id}',
  GET_HEALTH_TOOL_BABY_GROWTH_INFO: 'health-tools/baby-growth-tracking/info',
}

export const ADMIN_PATHS = {
  BASE_API_PATH: '/',
  LOGIN: 'admin/login?website_url={website_url}',
  LOGOUT: 'admin/logout?website_url={website_url}',
  RESET_PASSWORD: 'admin/password/reset?website_url={website_url}',
  SEND_EMAIL_RESET_PASS: 'admin/password/email?website_url={website_url}',
  GET_PROFILE: 'admin/profile?website_url={website_url}',
  VIDEO_UPLOAD: 'admin/video/upload?website_url={website_url}',
  COMMUNITY: {
    LIST:
      'admin/community?website_url={website_url}&page={page}&items_per_page={pageSize}&is_hidden={isHidden}&is_active={isActive}',
    DETAIL: 'admin/community/{id}?website_url={website_url}',
    CREATE: 'admin/community/create?website_url={website_url}',
    UPDATE: 'admin/community/{id}/update?website_url={website_url}',
    DELETE: 'admin/community/{id}/delete?website_url={website_url}',
    DISCOVER: {
      LIST:
        'admin/topic/category?website_url={website_url}&community_id={communityId}',
      CATEGORIES: 'admin/discover/categories?website_url={website_url}',
      UPDATE: 'admin/topic/category/store?website_url={website_url}',
      DELETE: 'admin/topic/category/delete?website_url={website_url}',
    },
    TOOLS: {
      LIST:
        'admin/topic/tool?website_url={website_url}&community_id={communityId}',
      TOOLS: 'admin/tools?website_url={website_url}',
      UPDATE: 'admin/topic/tool/store?website_url={website_url}',
      DELETE: 'admin/topic/tool/delete?website_url={website_url}',
    },
    SUBOTS: {
      LIST:
        'admin/topic/subot?website_url={website_url}&community_id={communityId}',
      SUBOTS: 'admin/subot?website_url={website_url}',
      UPDATE: 'admin/topic/subot/store?website_url={website_url}',
      DELETE: 'admin/topic/subot/delete?website_url={website_url}',
    },
    BANNER: {
      GET: 'admin/community/banner/{id}?website_url={website_url}',
      CREATE: 'admin/community/banner/create/{id}?website_url={website_url}',
      UPDATE: 'admin/community/banner/{id}/update?website_url={website_url}',
      DELETE: 'admin/community/banner/{id}/delete?website_url={website_url}',
      SORT: 'admin/community/banner/sort/{id}?website_url={website_url}',
    },
  },
  TOPIC: {
    LIST:
      'admin/topic?website_url={website_url}&community_id={communityId}&items_per_page={pageSize}',
    DETAIL: 'admin/topic/{id}?website_url={website_url}',
    CREATE: 'admin/topic/create?website_url={website_url}',
    UPDATE: 'admin/topic/{id}/update?website_url={website_url}',
    DELETE: 'admin/topic/{id}/delete?website_url={website_url}',
    UPDATE_ORDER:
      'admin/topic/order/update?website_url={website_url}&_order={order}',
    // TOPIC_MAP: 'admin/topic-map/{communityId}?website_url={website_url}',
  },

  USER: {
    LIST: `admin/user/{type}?website_url={website_url}&keyword={key}&start_date={startDate}&end_date={endDate}&is_suspend={isSuspend}&topic_id={topicId}&community_id={communityId}&sort_by={sort}&page={page}&role={role}&items_per_page={pageSize}`,
    DETAIL: `admin/user/{type}/{id}?website_url={website_url}`,
    GET_ACTIVITY: `admin/user/{type}/{id}/activities?website_url={website_url}&page={page}`,
    SUSPEND: `admin/user/{type}/{id}/suspend?website_url={website_url}`,
    UNSUSPEND: `admin/user/{type}/{id}/unsuspend?website_url={website_url}`,
    INACTIVE: `admin/user/{type}/{id}/inactive?website_url={website_url}`,
    DELETE: `admin/user/{type}/{id}/delete?website_url={website_url}`,
    CREATE: `admin/user/{type}/create?website_url={website_url}`,
    UPDATE: `admin/user/{type}/{id}/update?website_url={website_url}`,
    UPDATE_PERMISSION: `admin/user/{type}/{id}/update?website_url={website_url}&_permission=1`,
    UPDATE_ROLE: `admin/user/{type}/{id}/update?website_url={website_url}&_role=1`,
    LIST_PERMISSION: `admin/permission?website_url={website_url}`,
    SEND_PRIVATE_EMAIL: `admin/user/member/{id}/sent?website_url={website_url}`,
    UPGRADE_MEMBER: `admin/user/member/{id}/upgrade?website_url={website_url}`,
    COUNT_SEARCH_RESULT_BY_USER_TYPE:
      'admin/user/{userType}/search?keyword={keyword}&website_url={website_url}',
  },
  COMMENT: {
    LIST:
      'admin/comment?website_url={website_url}&post_id={postId}&community_id={communityId}&user_id={userId}&page={page}&parent_id={parentId}',
    DELETE: 'admin/comment/{id}/delete?website_url={website_url}',
    CREATE: 'admin/comment/create?website_url={website_url}',
    REPLY: 'admin/comment/reply?website_url={website_url}',
    IMAGE_UPLOAD: 'admin/comment/image/upload?website_url={website_url}',
    SET_SENSITIVE: 'admin/comment/{id}/sensitive?website_url={website_url}',
    MARK_READ_COMMENTS:
      'admin/user/read-comments?website_url={website_url}&comment_ids={listId}',
    DETAIL: 'admin/comment/{id}?website_url={website_url}',
  },
  POST: {
    LIST:
      'admin/post?website_url={website_url}&topic_id={topicId}&post_by={postBy}&keyword={key}&report_start_date={startDate}&report_end_date={endDate}&user_id={userId}&community_id={communityId}&page={page}&filter_comment={filterComment}&items_per_page={pageSize}&sort_by={sortBy}&sort_order={sortOrder}',
    DETAIL: 'admin/post/{id}?website_url={website_url}',
    CREATE: 'admin/post/create?website_url={website_url}',
    UPDATE: 'admin/post/{id}/update?website_url={website_url}',
    UPDATE_STATUS: 'admin/post/{id}/update?website_url={website_url}&_status=1',
    DELETE: 'admin/post/{id}/delete?website_url={website_url}',
    MARK_READ: 'admin/user/read-post/{id}?website_url={website_url}',
    MARK_READ_ALL_COMMENT:
      'admin/user/read-comment-with-post/{id}?website_url={website_url}',
    COUNT_SEARCH_RESULT:
      'admin/post/search?keyword={keyword}&website_url={website_url}',
  },
  REPORTED_POST: {
    LIST:
      'admin/reported-post?website_url={website_url}&page={page}&reported_id={reportedId}&community_id={communityId}&topic_id={topicId}&report_start_date={startDate}&report_end_date={endDate}&is_approved={isApproved}&is_rejected={isRejected}&reason={reason}',
    APPROVE_REJECT: 'admin/reported-post/{id}?website_url={website_url}',
  },
  GET_NOTIFICATION:
    'admin/notification?website_url={website_url}&user_id={userId}',
  MODERATION: {
    GET: 'admin/moderation?website_url={website_url}&type={type}',
    UPDATE: 'admin/moderation/create?website_url={website_url}',
  },
  REPORTED_COMMENT: {
    LIST: `admin/reported-comment?website_url={website_url}&community_id={communityId}&topic_id={topicId}&report_start_date={startDate}&report_end_date={endDate}&is_approved={isApproved}&is_rejected={isRejected}&reason={reason}&page={page}&reported_id={reportedId}`,
    APPROVE_REJECT: `admin/reported-comment/{id}?website_url={website_url}`,
  },
  SEARCH_USER:
    'admin/profile/search?website_url={website_url}&name={name}&sort_by=name',
  POPULAR_POSTS: {
    LIST: 'admin/options?website_url={website_url}&meta_key=popular_post',
    CREATE: 'admin/popular-post/store?website_url={website_url}',
  },
  BANNER: {
    LIST: 'admin/banners?website_url={website_url}',
    SORT: 'admin/banner/sort?website_url={website_url}',
    CREATE: 'admin/banner/create?website_url={website_url}',
    UPDATE: 'admin/banner/{id}/update?website_url={website_url}',
    DELETE: 'admin/banner/{id}/delete?website_url={website_url}',
  },
  ADD_COMMUNITY_GUIDES: {
    SAVE: 'admin/expert/store?website_url={website_url}',
    LIST: 'admin/options?website_url={website_url}&meta_key=expert_community',
  },
  VIDEO_BANNER: {
    GET: 'admin/options?website_url={website_url}&meta_key=video_community',
    SAVE: 'admin/video/store?website_url={website_url}',
  },
  STATISTIC_SETTING: {
    LIST: 'admin/static-numbers?website_url={website_url}',
    SAVE: 'admin/static-number/store?website_url={website_url}',
  },
}
